// 🚨 **TODO.md T-91 / F-113. A module that binds delegated handlers and is reachable from more than one
// pack tree must make its own binding idempotent — the guard belongs HERE, not on the initialisers that
// call it.** `packs/application.js` runs `clientFunctions()` for every ADMIN on every desktop page while
// `customers/index.js` and four other packs run `customerFunctions()`, so anything both invoke is invoked
// twice. Guarding those two instead was tried and **does not work**: they are different initialisers, so a
// module both of them call still runs twice. **The mutation that proved it — adding
// `functions_contact_person()` to `clientFunctions` — produced THREE contact-person rows from one click
// with initialiser-level guards in place.** `.add_contact_person` appends a row, so a second binding
// appends a second row.
//
// ✅ **The mechanism is a namespaced `off()`/`on()` as of 2026-10-12 (F-113), replacing a `claimOnce`
// registry.** Rationale, because the registry was not obviously worse: `off('.ns').on('.ns')` is idempotent
// **by construction** and coordinates with nothing, whereas `claimOnce` required `resetClaims()` to have run
// first on every navigation — true only while `application.js` held the single `turbolinks:load` listener.
// ⚠️ **A pack adding its own listener would have got a DEAD PAGE**, handlers never bound, which is a worse
// failure than the double binding being prevented. The registry also guarded the module that *cannot*
// double-fire (this one has one caller) while `src/historyLoadMore.js` — the only genuine cross-tree overlap,
// two callers — already used `off()/on()`. So this is the mechanism that was actually load-bearing here.
//
// 🚨 **ONE leading `off('.contactPerson')`, not an `off()` before each `on()` — and this is the part that
// would fail silently.** `src/historyLoadMore.js` writes `off('click.ns').on('click.ns', …)` because it
// binds **once**. This module binds **three** times, so repeating that per binding would make each `off`
// wipe the two before it and leave only the last handler attached. `off('.ns')` with no event type clears
// every event in the namespace at once, which is why it is hoisted above all three.
// 📌 Per navigation is automatic here: Turbolinks replaces `<body>`, so `#offcanvasRight` is a new element
// each visit with no handlers on it, and the `off()` is simply a no-op on a fresh node. No reset hook needed.
export default () => {
  $('#offcanvasRight').off('.contactPerson')

  $('#offcanvasRight').on('click.contactPerson', '.add_contact_person', function(event) {
    dirty = true

    var regexp, time
    time = new Date().getTime()
    regexp = new RegExp($(this).data('id'), 'g')
    $(this).closest('.tab-pane').find('.contact_person_rows').append($(this).data('fields').replace(regexp, time))
    
    if ($(this).closest('.tab-pane').find('.contact_person_rows .contact_person:not(.d-none)').length === 1) {
      $(this).closest('.tab-pane').find('.contact_person_rows .contact_person').last().find('.select_main_contact').prop('checked', true)
    }

    $(this).blur()

    return event.preventDefault()
  })

  $('#offcanvasRight').on('click.contactPerson', '.remove_contact_person_row', function(event) {
    dirty = true

    $(this).prev('input[type=hidden]').val('1')
    $(this).closest('.row').addClass('d-none')
    $(this).closest('.contact_person_rows').find('.row').not('.d-none').last().find('.hr').addClass('d-none')

    return event.preventDefault()
  })
  
  $('#offcanvasRight').on('change.contactPerson', '.contact_person_rows .select_main_contact', function(event) {
    if ($(this).is(':checked')) {
      $('#contact-people .select_main_contact').prop('checked', false)
      $('#contact-people .contact_person_rows .remove_contact_person_row').removeClass('d-none')
    }
    $(this).prop('checked', true)
    $(this).closest('.contact_person').find('.remove_contact_person_row').addClass('d-none')
  })
}